import { Component, OnInit } from '@angular/core';
import { MasterBlogComponent } from '../../blog/master-blog/master-blog.component';

@Component({
  selector: 'app-news-category',
  templateUrl: './news-category.component.html',
})
export class NewsCategoryComponent extends MasterBlogComponent {

  masterList = []

  
  ngOnInit(){

    super.ngOnInit()
    this.init()
  }
    async init(){

    this.masterList = await this.fetchMasterList()
  }

fetchMasterList(){

  return this.ERPAPI.post('crm/newseventcategory/search', {}).then(res => res.object)
}

}




// WEBPACK FOOTER //
// ./src/app/components/blog/news-category/news-category.component.ts